module.exports = __webpack_public_path__ + "static/montserrat-medium-webfont-1dc3e65c2c54e1ca8f9bd7d572dbd060.woff";